
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8bw1z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $h1ewt = parcelRequire("h1ewt");


var $9gE7g = parcelRequire("9gE7g");


var $cLo2u = parcelRequire("cLo2u");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $lsxnT = parcelRequire("lsxnT");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $ivb8S = parcelRequire("ivb8S");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $kM55L = parcelRequire("kM55L");


var $7aRa9 = parcelRequire("7aRa9");


var $dPJCf = parcelRequire("dPJCf");


var $6DT7W = parcelRequire("6DT7W");


var $5u6LZ = parcelRequire("5u6LZ");


var $8RR7m = parcelRequire("8RR7m");







const $913c9f7b92c5afc8$var$useAccountIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('accountId');
const $913c9f7b92c5afc8$var$useUsernameQueryParam = (0, $dPJCf.createSingleQueryParamHook)('username');
const $913c9f7b92c5afc8$var$useGrantAccessQueryParam = (0, $dPJCf.createSingleQueryParamHook)('grantAccess');
const $913c9f7b92c5afc8$export$2914b3c0c287db = ()=>{
    const accountIdRaw = $913c9f7b92c5afc8$var$useAccountIdQueryParam();
    const username = $913c9f7b92c5afc8$var$useUsernameQueryParam();
    const grantAccess = $913c9f7b92c5afc8$var$useGrantAccessQueryParam();
    const shouldShowGrantAccess = Boolean(grantAccess && accountIdRaw || username);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const clearGrantAccessQueryParams = (0, $42omo.useCallback)(()=>{
        setQueryParams({
            grantAccess: undefined,
            accessType: undefined,
            accountId: undefined,
            username: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    return {
        shouldShowGrantAccess: shouldShowGrantAccess,
        clearGrantAccessQueryParams: clearGrantAccessQueryParams
    };
};



var $b8XTE = parcelRequire("b8XTE");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $e4o8D = parcelRequire("e4o8D");


var $hkzol = parcelRequire("hkzol");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $lfFzM = parcelRequire("lfFzM");


var $eoU1C = parcelRequire("eoU1C");


var $6fwOO = parcelRequire("6fwOO");


var $d35qt = parcelRequire("d35qt");


var $frIzR = parcelRequire("frIzR");




















var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");




/**
 * @generated SignedSource<<66bbabd2227cd43e0ef101ef9354bd52>>
 * @relayHash e476390ffa12b3e505bd7e8ac519e061
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755
const $927357fa0afdf6f0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "e476390ffa12b3e505bd7e8ac519e061",
            "id": "21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$927357fa0afdf6f0$var$node.hash = "20811ee88362a051210b331b739d34c1";
var $927357fa0afdf6f0$export$2e2bcd8739ae039 = $927357fa0afdf6f0$var$node;


/**
 * @generated SignedSource<<e1a4f7548a5d983db48ae03c927ef50e>>
 * @relayHash 3ba2473df321be430db6c856602e1cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482
const $b4dea9a5255d2c1f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentAccessRequestInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "updateContentAccessRequestInput",
                    "variableName": "updateContentAccessRequestInput"
                }
            ],
            "concreteType": "ConfluenceUpdateContentAccessRequestPayload",
            "kind": "LinkedField",
            "name": "confluence_updateContentAccessRequest",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3ba2473df321be430db6c856602e1cfc",
            "id": "276d3b41fdfa3d291bf08ded53ed193db1a7ba6d83bd886ac6ec292d3dabf482",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsMutation",
            "operationKind": "mutation",
            "text": "mutation useRealtimeAccessRequestsFlagsMutation($cloudId:ID!,$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId,updateContentAccessRequestInput:$updateContentAccessRequestInput){success,errors{message}}}"
        }
    };
}();
$b4dea9a5255d2c1f$var$node.hash = "42de35f8c9cecb62158728d903eff6a2";
var $b4dea9a5255d2c1f$export$2e2bcd8739ae039 = $b4dea9a5255d2c1f$var$node;


/**
 * @generated SignedSource<<b29b6b1870e96345ffaf6af4dcf61f2a>>
 * @relayHash cc07dc4570c5f23dcae6dba3e01bc64f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884
const $4ea839717298c820$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 5,
            "kind": "LocalArgument",
            "name": "duration"
        },
        {
            "defaultValue": 10,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "duration",
                    "variableName": "duration"
                },
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "ConfluenceLatestPendingRequests",
            "kind": "LinkedField",
            "name": "confluence_getLatestPendingRequests",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceContentAccessRequest",
                    "kind": "LinkedField",
                    "name": "latestPendingRequest",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "requestAccessType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creatorAaid"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "creationDateTimestamp"
                        },
                        {
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPrimary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cc07dc4570c5f23dcae6dba3e01bc64f",
            "id": "869aa59f186c59156b49e7fd84b080a9f741fa74d96ee0e9093d8be9fba90884",
            "metadata": {},
            "name": "useRealtimeAccessRequestsFlagsQuery",
            "operationKind": "query",
            "text": "query useRealtimeAccessRequestsFlagsQuery($cloudId:ID!,$contentId:ID!,$duration:Int=5,$limit:Int=10,$start:String){confluence_getLatestPendingRequests(cloudId:$cloudId,contentId:$contentId,duration:$duration,limit:$limit,start:$start){latestPendingRequest{id,requestAccessType,creatorAaid,creationDateTimestamp,user{id,displayName,photos{isPrimary,value}}}}}"
        }
    };
}();
$4ea839717298c820$var$node.hash = "b94cab17722d3b349c6aeac7cfa04a8f";
var $4ea839717298c820$export$2e2bcd8739ae039 = $4ea839717298c820$var$node;














var $a2xFu = parcelRequire("a2xFu");


var $i9VoI = parcelRequire("i9VoI");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $iquRY = parcelRequire("iquRY");


var $8aF6s = parcelRequire("8aF6s");


var $eRpR8 = parcelRequire("eRpR8");





var $7Sm4c = parcelRequire("7Sm4c");


var $dwkNQ = parcelRequire("dwkNQ");


var $7QoAs = parcelRequire("7QoAs");


var $f2UnK = parcelRequire("f2UnK");


var $1UApO = parcelRequire("1UApO");


var $2Oud5 = parcelRequire("2Oud5");

const $ba14d5ed8e7789e1$export$7e0819e7cb643ce3 = 525600;
const $ba14d5ed8e7789e1$export$c47be26a650fe21 = 5;
const $ba14d5ed8e7789e1$export$e58e41b464377560 = $ba14d5ed8e7789e1$export$c47be26a650fe21 * 60000;
const $ba14d5ed8e7789e1$export$b8de370ad22b4906 = (0, $1UApO.keys).LAST_SHOWN_REALTIME_REQUEST_CREATED_AT;
const $ba14d5ed8e7789e1$export$4000ed65840ab68a = (timestamp)=>{
    return Date.now() - timestamp < $ba14d5ed8e7789e1$export$e58e41b464377560;
};
const $ba14d5ed8e7789e1$export$3dee0973a5558286 = (timestamp)=>!$ba14d5ed8e7789e1$export$4000ed65840ab68a(timestamp);
const $ba14d5ed8e7789e1$export$289c54b917400e1c = (contentId, newTimestamp)=>{
    (0, $2Oud5.setCachedTuple)(contentId, newTimestamp, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$4000ed65840ab68a);
};
const $ba14d5ed8e7789e1$export$8d67ec31af2e3b08 = (contentId, incomingRequestTimestamp)=>{
    return incomingRequestTimestamp > (0, $2Oud5.getCachedTimestamp)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906) && $ba14d5ed8e7789e1$export$4000ed65840ab68a(incomingRequestTimestamp);
};
const $ba14d5ed8e7789e1$export$37d57e4c435593ab = (contentId)=>{
    (0, $2Oud5.removeCachedTuple)(contentId, $ba14d5ed8e7789e1$export$b8de370ad22b4906, $ba14d5ed8e7789e1$export$3dee0973a5558286);
};












var $2Pg7f = parcelRequire("2Pg7f");


var $1chEN = parcelRequire("1chEN");

const $1ca745aa2c0dd46c$var$i18n = (0, $cgtv4.defineMessages)({
    singleRequestTitleView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-view",
        defaultMessage: "{name} wants to view this content"
    },
    singleRequestTitleEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.single-request-title-edit",
        defaultMessage: "{name} wants to edit this content"
    },
    twoRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.two-requests-title",
        defaultMessage: "{firstName} and {secondName} want to access this content"
    },
    multipleRequestsTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.multiple-requests-title",
        defaultMessage: "{firstName} and {remainingCount} others want to access this content"
    },
    spaceAndParentRestriction: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-and-parent-restriction",
        defaultMessage: "They'll also need to be added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    spaceRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.space-restriction-only",
        defaultMessage: "They'll also need to be added to the space."
    },
    parentRestrictionOnly: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.parent-restriction-only",
        defaultMessage: "They'll also need to be added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}."
    },
    approveButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.approve-button",
        defaultMessage: "Approve"
    },
    viewDetailsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.view-details-button",
        defaultMessage: "View details"
    },
    denyButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.deny-button",
        defaultMessage: "Deny"
    },
    reviewRequestsButton: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.review-requests-button",
        defaultMessage: "Review requests"
    },
    successSpaceAndParentRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-view",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now view this content."
    },
    successSpaceAndParentRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-and-parent-restriction-edit",
        defaultMessage: "{displayName} was added to the space and to {parentRestrictionCount, plural, one {# parent item} other {# parent items}}. They can now edit this content."
    },
    successSpaceRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-view",
        defaultMessage: "{displayName} was added to the space and can now view this content."
    },
    successSpaceRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-space-restriction-only-edit",
        defaultMessage: "{displayName} was added to the space and can now edit this content."
    },
    successParentRestrictionOnlyView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-view",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now view this content."
    },
    successParentRestrictionOnlyEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-parent-restriction-only-edit",
        defaultMessage: "{displayName} was added to {parentRestrictionCount, plural, one {# parent item} other {# parent items}} and can now edit this content."
    },
    successNoRestrictionView: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-view",
        defaultMessage: "{displayName} can now view this content."
    },
    successNoRestrictionEdit: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.success-no-restriction-edit",
        defaultMessage: "{displayName} can now edit this content."
    }
});
const $1ca745aa2c0dd46c$export$9ddb107f546f744e = (requests, formatMessage)=>{
    if (requests.length === 1) {
        const onlyRequest = requests[0];
        const name = onlyRequest?.user?.displayName;
        const accessType = onlyRequest?.requestAccessType;
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.singleRequestTitleEdit : $1ca745aa2c0dd46c$var$i18n.singleRequestTitleView;
        return formatMessage(messageKey, {
            name: name
        });
    }
    if (requests.length > 1) {
        const firstName = requests[0]?.user?.displayName;
        if (requests.length === 2) {
            const secondName = requests[1]?.user?.displayName;
            return formatMessage($1ca745aa2c0dd46c$var$i18n.twoRequestsTitle, {
                firstName: firstName,
                secondName: secondName
            });
        }
        const remainingCount = requests.length - 1;
        return formatMessage($1ca745aa2c0dd46c$var$i18n.multipleRequestsTitle, {
            firstName: firstName,
            remainingCount: remainingCount
        });
    }
    // Should not happen, because method gets invoked if there's at least one request
    return '';
};
const $1ca745aa2c0dd46c$export$6fedf4d3a712a334 = (restrictedUserPrincipalInfo)=>{
    const hasSpaceRestriction = restrictedUserPrincipalInfo?.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE) ?? false;
    const parentRestrictionCount = restrictedUserPrincipalInfo?.restrictedResources?.reduce((res, curr)=>{
        const isParentRestriction = curr?.resourceType !== (0, $1chEN.ResourceType).SPACE;
        return res + (isParentRestriction ? 1 : 0);
    }, 0) ?? 0;
    const hasParentRestriction = parentRestrictionCount > 0;
    const isBlocked = hasSpaceRestriction || hasParentRestriction;
    return {
        isBlocked: isBlocked,
        hasSpaceRestriction: hasSpaceRestriction,
        hasParentRestriction: hasParentRestriction,
        parentRestrictionCount: parentRestrictionCount
    };
};
const $1ca745aa2c0dd46c$export$89885fb2503e60cf = (requests, formatMessage, restrictedUserPrincipalInfo)=>{
    if (requests.length === 1 && restrictedUserPrincipalInfo) {
        const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
        if (hasSpaceRestriction && hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceAndParentRestriction, {
            parentRestrictionCount: parentRestrictionCount
        });
        else if (hasSpaceRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.spaceRestrictionOnly);
        else if (hasParentRestriction) return formatMessage($1ca745aa2c0dd46c$var$i18n.parentRestrictionOnly, {
            parentRestrictionCount: parentRestrictionCount
        });
    }
    return null;
};
const $1ca745aa2c0dd46c$export$5afde147a40aa32c = (requests)=>{
    const avatarData = requests.flatMap((request)=>request?.user?.displayName && request?.requestAccessType && request?.user?.id ? {
            name: request.user.displayName,
            src: request.user.photos?.find((photo)=>photo?.isPrimary)?.value ?? undefined,
            key: request.user.id
        } : []);
    const maxCount = avatarData.length === 1 ? 1 : 2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarData,
        maxCount: maxCount
    });
};
const $1ca745aa2c0dd46c$export$8a8be71612a7c860 = (requests, restrictedUserPrincipalInfo, processRequest, onReview, onViewDetails, hideFlag, formatMessage)=>{
    if (requests.length === 1) {
        const approveRequest = ()=>{
            processRequest(requests[0], 'APPROVE', restrictedUserPrincipalInfo);
            hideFlag();
        };
        const denyRequest = ()=>{
            processRequest(requests[0], 'DENY', undefined);
            hideFlag();
        };
        const primaryAction = {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.approveButton),
            onClick: approveRequest
        };
        const secondaryAction = restrictedUserPrincipalInfo ? {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.viewDetailsButton),
            onClick: onViewDetails
        } : {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.denyButton),
            onClick: denyRequest
        };
        return [
            primaryAction,
            secondaryAction
        ];
    }
    if (requests.length > 1) return [
        {
            content: formatMessage($1ca745aa2c0dd46c$var$i18n.reviewRequestsButton),
            onClick: onReview
        }
    ];
    return [];
};
const $1ca745aa2c0dd46c$export$94e073f79b81300f = (restrictedUserPrincipalInfo, displayName, accessType, formatMessage)=>{
    const { hasSpaceRestriction: hasSpaceRestriction, hasParentRestriction: hasParentRestriction, parentRestrictionCount: parentRestrictionCount } = $1ca745aa2c0dd46c$export$6fedf4d3a712a334(restrictedUserPrincipalInfo);
    if (hasSpaceRestriction && hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceAndParentRestrictionView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    } else if (hasSpaceRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successSpaceRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName
        });
    } else if (hasParentRestriction) {
        const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyEdit : $1ca745aa2c0dd46c$var$i18n.successParentRestrictionOnlyView;
        return formatMessage(messageKey, {
            displayName: displayName,
            parentRestrictionCount: parentRestrictionCount
        });
    }
    const messageKey = accessType === 'EDIT' ? $1ca745aa2c0dd46c$var$i18n.successNoRestrictionEdit : $1ca745aa2c0dd46c$var$i18n.successNoRestrictionView;
    return formatMessage(messageKey, {
        displayName: displayName
    });
};
const $1ca745aa2c0dd46c$export$9ffd6710da84d7ef = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { onDestroy: onDestroy, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onDestroy) {
        t1 = ()=>onDestroy;
        t2 = [
            onDestroy
        ];
        $[0] = onDestroy;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $42omo.useEffect)(t1, t2);
    return children;
};
const $1ca745aa2c0dd46c$export$6cbbb5b074df5c76 = (requests)=>requests.reduce((result, current)=>result + (current?.id ?? ''), '');








const $451ee996e81d8755$export$4e0e446ffa50ddc0 = ()=>{
    const $ = (0, $frIzR.c)(2);
    const [isActive, setIsActive] = (0, $42omo.useState)(document?.visibilityState === "visible");
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let timer;
            const handleVisibilityChange = ()=>{
                clearTimeout(timer);
                if (document?.visibilityState === "visible") timer = setTimeout(()=>{
                    setIsActive(true);
                }, 8000);
                else setIsActive(false);
            };
            document?.addEventListener("visibilitychange", handleVisibilityChange);
            return ()=>{
                clearTimeout(timer);
                document?.removeEventListener("visibilitychange", handleVisibilityChange);
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $42omo.useEffect)(t0, t1);
    return isActive;
};


const $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED = 'REQUEST_ALREADY_PROCESSED';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG = 'realtime-access-request-flag';
const $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG}-id`;
const $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID = '26d75a6e-ad72-42c3-bf30-007d3ebae9ed';
const $e6f9393b1f903716$var$NOOP = ()=>{};
const $e6f9393b1f903716$var$i18n = (0, $cgtv4.defineMessages)({
    requestApprovedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-approved-success",
        defaultMessage: "Request approved"
    },
    requestDeniedSuccess: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-denied-success",
        defaultMessage: "Request denied"
    },
    denialSuccessDescription: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.denial-success-description",
        defaultMessage: "{displayName}'s access to this content won't change."
    },
    requestAlreadyProcessedTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.request-already-processed-title",
        defaultMessage: "Someone already responded to this request"
    },
    errorResolvingRequestTitle: {
        id: "share-and-restrict-dialog.realtime-access-request-flag.error-resolving-request-title",
        defaultMessage: "We ran into a problem resolving the access request. Try again later."
    }
});
const $e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwkNQ.ResolveRestrictionsDialog), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery = (0, $4ea839717298c820$export$2e2bcd8739ae039);
const $e6f9393b1f903716$export$28935defd579c67a = (0, $b4dea9a5255d2c1f$export$2e2bcd8739ae039);
const $e6f9393b1f903716$var$ResolveRestrictionsMutation = (0, $927357fa0afdf6f0$export$2e2bcd8739ae039);
const $e6f9393b1f903716$export$e14a96ba31dd30b0 = (requests, userId)=>(0, $9wGTI.fg)('cc_fe_realtime_access_requests_show_own_requests') ? requests : requests.filter((request)=>request?.creatorAaid !== userId);
const $e6f9393b1f903716$export$126feeec2567e438 = ({ userId: userId, cloudId: cloudId, edition: edition, contentId: contentId, contentType: contentType, pageTitle: pageTitle, flags: flags, onReviewRequests: onReviewRequests })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isRbacEnabled: isRbacEnabled, loading: rbacStatusLoading } = (0, $iquRY.useSpaceRoleMode)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const [isInitialLoad, setIsInitialLoad] = (0, $42omo.useState)(true);
    const isTabActive = (0, $451ee996e81d8755$export$4e0e446ffa50ddc0)();
    const skipConditions = hasError || rbacStatusLoading || !isTabActive;
    const markAsErrored = (0, $42omo.useCallback)((error)=>{
        setHasError(true);
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, []);
    const fireAnalyticEvent = (0, $42omo.useCallback)((args)=>{
        createAnalyticsEvent({
            type: args.eventType,
            data: {
                source: args.source,
                action: args.action,
                actionSubject: args.actionSubject,
                actionSubjectId: args.actionSubjectId,
                attributes: args.attributes
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const [mutateRequest] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$export$28935defd579c67a);
    const [resolveRestrictionsForSubjects] = (0, $308Wd.useMutationInterop)($e6f9393b1f903716$var$ResolveRestrictionsMutation);
    const onProcessRequestClick = (0, $42omo.useCallback)(async (request, decision, restrictedUserPrincipalInfo)=>{
        // Purely to satisfy the linter
        if (!request || !request.id || !request.requestAccessType || !request.user || !request.user.id || !request.user.displayName || !request.creatorAaid || !request.creationDateTimestamp) return;
        const result = await mutateRequest({
            variables: {
                cloudId: cloudId,
                updateContentAccessRequestInput: {
                    contentId: contentId,
                    requestId: request.id,
                    accessType: request.requestAccessType,
                    accessRequestedAccountId: request.user.id,
                    approvalDecision: decision
                }
            }
        });
        let successfulMutation = result.data?.confluence_updateContentAccessRequest?.success;
        const requestAlreadyProcessed = result?.data?.confluence_updateContentAccessRequest?.errors?.find((err)=>err?.message === $e6f9393b1f903716$var$REQUEST_ALREADY_PROCESSED);
        // If user is blocked, run mutation to resolve restrictions
        if (successfulMutation && decision === 'APPROVE' && restrictedUserPrincipalInfo) {
            const rbacSpaceRole = request.requestAccessType === 'EDIT' ? $e6f9393b1f903716$var$SPACE_COLLABORATOR_ROLE_ID : $e6f9393b1f903716$var$SPACE_VIEWER_ROLE_ID;
            const spaceRoleId = isRbacEnabled ? rbacSpaceRole : null;
            const subjectId = request.creatorAaid;
            const subjectType = 'USER';
            const result_0 = await resolveRestrictionsForSubjects({
                variables: {
                    contentId: Number(contentId),
                    accessType: request.requestAccessType,
                    subjects: [
                        {
                            subjectId: subjectId,
                            subjectType: subjectType
                        }
                    ],
                    spaceRoleId: spaceRoleId
                }
            });
            successfulMutation = result_0?.data?.resolveRestrictionsForSubjects?.success;
        }
        if (successfulMutation) {
            flags.showSuccessFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_SUCCESS`,
                title: formatMessage(decision === 'APPROVE' ? $e6f9393b1f903716$var$i18n.requestApprovedSuccess : $e6f9393b1f903716$var$i18n.requestDeniedSuccess),
                description: decision === 'APPROVE' ? (0, $1ca745aa2c0dd46c$export$94e073f79b81300f)(restrictedUserPrincipalInfo, request.user.displayName, request.requestAccessType, formatMessage) : formatMessage($e6f9393b1f903716$var$i18n.denialSuccessDescription, {
                    displayName: request.user.displayName
                }),
                isAutoDismiss: true
            });
            if (decision === 'APPROVE') fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'granted',
                actionSubject: 'access',
                actionSubjectId: 'grantAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
            else fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'denyAccess',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    accessType: request.requestAccessType,
                    processingTime: Date.now() - request.creationDateTimestamp,
                    creationDateTimestamp: request.creationDateTimestamp,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
        } else if (requestAlreadyProcessed) {
            flags.showInfoFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_INFO`,
                title: formatMessage($e6f9393b1f903716$var$i18n.requestAlreadyProcessedTitle),
                isAutoDismiss: true
            });
            fireAnalyticEvent({
                eventType: 'sendTrackEvent',
                action: 'alreadyProcessed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    attemptedDecision: decision,
                    accessType: request.requestAccessType,
                    ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo)
                }
            });
        } else {
            flags.showErrorFlag({
                id: `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_ERROR`,
                title: formatMessage($e6f9393b1f903716$var$i18n.errorResolvingRequestTitle),
                isAutoDismiss: true
            });
            const err_0 = result?.data?.confluence_updateContentAccessRequest?.errors?.[0];
            const message = err_0?.message || 'unknown';
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'accessRequestsRealtimeFlagMutation',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    requestId: request.id,
                    contentId: contentId,
                    accessType: request.requestAccessType,
                    accountId: request.creatorAaid,
                    message: message
                }
            });
        }
    }, [
        cloudId,
        contentId,
        isRbacEnabled,
        flags,
        mutateRequest,
        resolveRestrictionsForSubjects,
        formatMessage,
        fireAnalyticEvent
    ]);
    const maybeShowRealtimeFlag = (0, $42omo.useCallback)(async (data, eventName)=>{
        // This is only used for analytics
        const queryTrigger = eventName ?? (isInitialLoad ? 'initialLoad' : 'tabVisible');
        if (isInitialLoad) setIsInitialLoad(false);
        const accessRequests = $e6f9393b1f903716$export$e14a96ba31dd30b0(data.confluence_getLatestPendingRequests?.latestPendingRequest ?? [], userId);
        (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).updateIndicatorVisibility(contentId, accessRequests[0]?.creationDateTimestamp ?? 0, eventName === 'contentAccessRequested' ? 'partial' : 'full', accessRequests?.length ?? 0);
        if (accessRequests.length === 0) {
            // If a cached "last seen" timestamp for a realtime flag exists and it's > 5 minutes old
            // Then we can clear the cache to avoid buildup
            (0, $ba14d5ed8e7789e1$export$37d57e4c435593ab)(contentId);
            return;
        }
        // We just need to remove requests older than the "last seen" one in the cache
        // Also ensure all requests have bare minimum info to display flag correctly
        const filteredRequests = accessRequests.filter((request_0)=>{
            const hasAllNecessaryData = request_0?.user?.displayName && request_0?.requestAccessType;
            const requestCreationTimestamp = Number(request_0?.creationDateTimestamp);
            const isMoreRecentThanLastSeenRequest = (0, $ba14d5ed8e7789e1$export$8d67ec31af2e3b08)(contentId, requestCreationTimestamp);
            return hasAllNecessaryData && isMoreRecentThanLastSeenRequest;
        });
        const latestIncomingRequestCreatedAt = Number(filteredRequests[0]?.creationDateTimestamp);
        if (filteredRequests.length === 0) return;
        // ID of any realtime flag that might be currently displayed
        const EXISTING_FLAG_ID = flags.state.flags.find(({ id: id })=>id.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
        // ID of the flag that we're about to display.
        // The suffix is a concatenated list of all the request ID-s displayed in the flag.
        // It helps us to know if the existing and new flag are going to be the same. See the edge case below
        const NEXT_FLAG_ID = `${$e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG_ID}_${(0, $1ca745aa2c0dd46c$export$6cbbb5b074df5c76)(filteredRequests)}`;
        /**
     * EDGE CASE: Flag gets hidden and exact same flag gets shown in its place.
     * This can happen because of tab inactivity monitoring. To reproduce:
     *
     * 1. Existing Realtime flag is showing on a page
     * 2. You click away into another tab.
     * 3. Click back on the original tab with the Realtime flag wihin 16s (autodismiss timeout)
     *    - we refetch all requests because the tab is now active again
     *    - the new request(s) are very likely the same as the ones already displayed in the flag
     *    - The existing flag gets hidden and a new flag with the same request(s) gets shown
     *    - To prevent this we just return early in this case
     *
     * This is likely to happen often as people click back and forth between tabs, so better to address it
     */ if (EXISTING_FLAG_ID === NEXT_FLAG_ID) return;
        /**
     * We cache the request as "seen" when the flag for it gets destroyed
     * However, if another realtime flag was shown WHILE the the current requests's flag is visible
     * Then we don't want to cache the current request to allow the current request to continue
     * showing in the newer flags' stacked display.
     *
     * As a reminder, requirements state that if a current flag is displayed and a new request comes in,
     * then the current flag needs to be replaced by a new flag that shows both of the requests with a facepile
     * for both users.
     *
     * If a third request comes in, then that second flag will get replaced with a third one, with the facepile
     * now showing 3 users, etc.
     *
     * Thus, to allow for this stacking of requests to occur, we only want to cache the last seen request when
     * the last flag in this request overlap sequence gets destroyed.
     * */ const onDestroy = ()=>{
            const skipCachingOfLastSeenFlag = flags.state.flags.find(({ id: id_0 })=>`${id_0}`.startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG) && id_0 !== NEXT_FLAG_ID);
            if (!skipCachingOfLastSeenFlag) (0, $ba14d5ed8e7789e1$export$289c54b917400e1c)(contentId, latestIncomingRequestCreatedAt);
        };
        let restrictedUserPrincipalInfo_0;
        let resolveRestrictionsDialogProps;
        let onViewDetailsClick = $e6f9393b1f903716$var$NOOP;
        const hideFlag = ()=>{
            flags.hideFlag(NEXT_FLAG_ID);
        };
        const onReviewRequestsClick = ()=>{
            onReviewRequests();
            hideFlag();
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'reviewRequests',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length
                }
            });
        };
        if (filteredRequests.length === 1) {
            const request_1 = filteredRequests[0];
            const user = request_1?.user;
            const accessType = request_1?.requestAccessType ?? 'VIEW';
            const addMode = accessType === 'EDIT' ? 'as-editor' : 'as-viewer';
            const userPrincipal = {
                id: user?.id ?? '',
                name: user?.displayName ?? '',
                avatarUrl: user?.photos?.find((photo)=>photo?.isPrimary)?.value ?? '',
                email: '',
                // not needed
                knownErrors: undefined,
                sitePermissionType: accessType
            };
            // Make the blocked access check
            const [{ showResolveRestrictionsDialog: showResolveRestrictionsDialog, showWarnRestrictionsDialog: showWarnRestrictionsDialog, restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection }] = await Promise.all([
                (0, $7QoAs.validateRestrictedPrincipals)({
                    contentId: contentId,
                    cloudId: cloudId,
                    edition: edition,
                    numberOfAncestors: 1,
                    addMode: // not needed, API will error out if < 10 layers of ancestors
                    addMode,
                    stagedUserPrincipals: [
                        userPrincipal
                    ],
                    setMasterState: ()=>{},
                    fireAnalyticEvent: // not needed
                    fireAnalyticEvent
                }),
                (0, $f2UnK.preloadSpaceRoleMode)(cloudId)
            ]);
            /** Early return if user is not empowered to resolve blocked access */ if (showWarnRestrictionsDialog) {
                fireAnalyticEvent({
                    eventType: 'sendUIEvent',
                    action: 'aborted',
                    actionSubject: 'realtimeFlag',
                    source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                    attributes: {
                        trigger: queryTrigger,
                        requestsDisplayed: filteredRequests.length,
                        ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
                    }
                });
                return;
            }
            if (showResolveRestrictionsDialog && restrictedUserPrincipals?.[0]) {
                restrictedUserPrincipalInfo_0 = restrictedUserPrincipals?.[0];
                onViewDetailsClick = ()=>{
                    showModal($e6f9393b1f903716$var$ResolveRestrictionsDialogWrapper, resolveRestrictionsDialogProps);
                    hideFlag();
                    fireAnalyticEvent({
                        eventType: 'sendUIEvent',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'viewDetails',
                        source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                        attributes: {
                            trigger: queryTrigger,
                            requestsDisplayed: filteredRequests.length,
                            ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
                        }
                    });
                };
                const approveRequest = ()=>{
                    onProcessRequestClick(request_1, 'APPROVE', restrictedUserPrincipalInfo_0);
                    hideFlag();
                };
                resolveRestrictionsDialogProps = {
                    contentId: contentId,
                    restrictedUserPrincipals: restrictedUserPrincipals,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection,
                    pageTitle: pageTitle,
                    addMode: addMode,
                    onComplete: approveRequest,
                    onClose: $e6f9393b1f903716$var$NOOP,
                    onCloseComplete: $e6f9393b1f903716$var$NOOP,
                    onSkip: $e6f9393b1f903716$var$NOOP,
                    showErrorFlag: flags.showErrorFlag,
                    triggeredBy: 'realtimeAccessRequestFlag'
                };
            }
        }
        const onFlagCloseButtonClick = ()=>{
            fireAnalyticEvent({
                eventType: 'sendUIEvent',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissRealtimeAccessRequestFlag',
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    trigger: queryTrigger,
                    requestsDisplayed: filteredRequests.length,
                    ...filteredRequests.length === 1 ? (0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0) : {}
                }
            });
        };
        await flags.showCustomFlag({
            id: NEXT_FLAG_ID,
            isAutoDismiss: true,
            autoDismissSeconds: 16,
            customIcon: (0, $1ca745aa2c0dd46c$export$5afde147a40aa32c)(filteredRequests),
            onClose: onFlagCloseButtonClick,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1ca745aa2c0dd46c$export$9ffd6710da84d7ef), {
                onDestroy: onDestroy
            }, (0, $1ca745aa2c0dd46c$export$9ddb107f546f744e)(filteredRequests, formatMessage)),
            description: (0, $1ca745aa2c0dd46c$export$89885fb2503e60cf)(filteredRequests, formatMessage, restrictedUserPrincipalInfo_0),
            actions: (0, $1ca745aa2c0dd46c$export$8a8be71612a7c860)(filteredRequests, restrictedUserPrincipalInfo_0, onProcessRequestClick, // Approves / Denies request based on arguments
            onReviewRequestsClick, // Opens USD -> Access Requests
            onViewDetailsClick, // Opens standalone version of Resolve Restrictions Modal
            hideFlag, formatMessage)
        });
        /**
     * Fire flag shown analytic
     */ fireAnalyticEvent({
            eventType: 'sendUIEvent',
            action: 'shown',
            actionSubject: 'realtimeFlag',
            source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
            attributes: {
                trigger: queryTrigger,
                requestsDisplayed: filteredRequests.length,
                ...(0, $1ca745aa2c0dd46c$export$6fedf4d3a712a334)(restrictedUserPrincipalInfo_0)
            }
        });
        /**
     * Only hide any existing flags AFTER the latest flag has been shown
     * This ensures that the onDestroy callback of the existing flag
     * Will realize there's a newer flag on the screen
     * And will thus skip caching the EXISTING_FLAG_ID's request as seen
     * This allows the request to coninue appearing in the facepile of any
     * Newer flags that are displayed after it
     */ if (EXISTING_FLAG_ID) await flags.hideFlag(EXISTING_FLAG_ID);
    }, [
        userId,
        cloudId,
        contentId,
        pageTitle,
        edition,
        onProcessRequestClick,
        onReviewRequests,
        fireAnalyticEvent,
        flags,
        showModal,
        formatMessage,
        isInitialLoad
    ]);
    const { refetch: refetch, error: error_0 } = (0, $jMyy4.useQueryInterop)($e6f9393b1f903716$var$UseRealtimeAccessRequestsQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            duration: (0, $ba14d5ed8e7789e1$export$7e0819e7cb643ce3)
        },
        skip: skipConditions,
        fetchPolicy: 'network-only',
        // This "onCompleted" runs only on initial load.
        onCompleted: maybeShowRealtimeFlag,
        onError: markAsErrored
    });
    if (error_0) {
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        if (hasError === false) setHasError(true);
    }
    const onDataReceived = (0, $42omo.useCallback)(async (eventName_0)=>{
        try {
            /**
       * Decide how far back in time we look to find existing pending requests.
       *
       * Option 1: eventName === 'contentAccessDecisionMade'
       * If it's after an existing request was just approved / denied, we want ALL requests
       * If no requests come back in response to that, then we can remove the 🔵 indicator
       *
       * Option 2: eventName === 'contentAccessRequested'
       * If it's after a new access request was just created, we only want to fetch the last
       * 5 minutes (or whatever short period we decide). This allows us to show a realtime flag
       * only for newly created requests that haven't been seen yet.
       * We cache the last seen realtime request creation date in localStorage.
       */ const lookbackPeriod = eventName_0 === 'contentAccessDecisionMade' ? (0, $ba14d5ed8e7789e1$export$7e0819e7cb643ce3) : (0, $ba14d5ed8e7789e1$export$c47be26a650fe21);
            const result_1 = await refetch({
                duration: lookbackPeriod,
                cloudId: cloudId,
                contentId: contentId
            });
            if (result_1.errors) {
                markAsErrored(result_1.errors[0]);
                return;
            }
            await maybeShowRealtimeFlag(result_1.data, eventName_0);
        } catch (e) {
            markAsErrored(e);
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'failed',
                actionSubject: 'onDataReceived',
                actionSubjectId: eventName_0,
                source: $e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG,
                attributes: {
                    name: e?.name,
                    message: e?.message
                }
            });
        }
    }, [
        refetch,
        cloudId,
        contentId,
        markAsErrored,
        maybeShowRealtimeFlag,
        fireAnalyticEvent
    ]);
    // Monitor when new pending requests get created
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessRequested',
        subscriberId: (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Monitor the approval / denial of existing pending requests
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        delta: 'contentAccessDecisionMade',
        subscriberId: (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        onDataReceived: onDataReceived,
        skip: skipConditions
    });
    // Cleanup effect when page is navigated away from
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // Subscribers need to be reset when the hook gets killed
            // This usually means that the share button got dismounted
            // And user navigated away from the current content
            (0, $eRpR8.NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE).resetSubscribers();
            // Databases and Whiteboards DON'T hide the flags when leaving the content
            // Live pages, regular pages DO hide the flags when leaving the content
            // Thus we choose to hide the flags everywhere to equalize behavior
            const existingFlagId = flags.state.flags.find(({ id: id_1 })=>id_1.toString().startsWith($e6f9393b1f903716$var$REALTIME_ACCESS_REQUEST_FLAG))?.id;
            if (existingFlagId) flags.hideFlag(existingFlagId);
        };
    }, [
        flags
    ]);
};


const $b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal = (0, $7aRa9.withFlags)(({ cloudId: cloudId, userId: userId, edition: edition, contentType: contentType, contentId: contentId, pageTitle: pageTitle, flags: flags, onReviewRequestsClick: onReviewRequests })=>{
    (0, $e6f9393b1f903716$export$126feeec2567e438)({
        userId: userId,
        cloudId: cloudId,
        edition: edition,
        onReviewRequests: onReviewRequests,
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        flags: flags
    });
    return null;
});
const $b7b8f942bb046fc6$export$c85837ac639c35b3 = (accessStatus)=>[
        null,
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS
    ].includes(accessStatus);
const $b7b8f942bb046fc6$export$6e9d9c4509b6c805 = (props)=>{
    const $ = (0, $frIzR.c)(5);
    const { cloudId: cloudId, userId: userId, edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isSSR = (0, $e4o8D.useRenderServerPlaceholder)();
    if (isSSR || !cloudId || !userId || !edition || edition === "FREE" || !isLoggedIn || $b7b8f942bb046fc6$export$c85837ac639c35b3(accessStatus)) return null;
    let t0;
    if ($[0] !== cloudId || $[1] !== edition || $[2] !== props || $[3] !== userId) {
        t0 = (0, $6mKj3.expValEquals)("cc_fe_realtime_access_requests", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7b8f942bb046fc6$var$RealtimeAccessRequestsInternal, {
            userId: userId,
            cloudId: cloudId,
            edition: edition,
            ...props
        }) : null;
        $[0] = cloudId;
        $[1] = edition;
        $[2] = props;
        $[3] = userId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $b7b8f942bb046fc6$export$6ad2e2265e081d0a = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
})($b7b8f942bb046fc6$export$6e9d9c4509b6c805);



var $Qy97i = parcelRequire("Qy97i");


var $4adOe = parcelRequire("4adOe");


var $gw4Bt = parcelRequire("gw4Bt");


var $38Ncj = parcelRequire("38Ncj");






















const $6663c77035b2c619$var$useShareAndRestrictButtonDataQuery = (0, $38Ncj.default);
const $6663c77035b2c619$var$tooltipMessages = (0, $cgtv4.defineMessages)({
    restricted: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.restricted",
        defaultMessage: "Restricted - Only specific people can access"
    },
    inherited: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.inherited",
        defaultMessage: "Restricted by a parent - Anyone on the parent item can access"
    },
    draft: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.draft",
        defaultMessage: "Open - Anyone in the space (with the link) can access"
    },
    openEdit: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openEdit",
        defaultMessage: "Open - Anyone in the space can edit"
    },
    openView: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.openView",
        defaultMessage: "Open - Anyone in the space can view"
    },
    public: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.public",
        defaultMessage: "Public - Anyone with the link can access"
    },
    error: {
        id: "share-and-restrict-dialog.controlled-share-button.tooltip.error",
        defaultMessage: "Access level failed to load"
    }
});
const $6663c77035b2c619$var$getIconAndTooltipFromData = (isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, isErrored, isUnpublishedDraft, hasRestrictions)=>{
    if (isErrored) return [
        'error',
        $6663c77035b2c619$var$tooltipMessages.error
    ];
    if (isPublicLinkOn) return [
        'public',
        $6663c77035b2c619$var$tooltipMessages.public
    ];
    if (hasViewRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.restricted
    ];
    if (hasInheritedRestrictions) return [
        'restricted',
        $6663c77035b2c619$var$tooltipMessages.inherited
    ];
    if (isUnpublishedDraft) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.draft
    ];
    if (hasRestrictions) return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openView
    ];
    return [
        'open',
        $6663c77035b2c619$var$tooltipMessages.openEdit
    ];
};
const $6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR = 'This is a Standard/Premium feature. You are currently subscribed to the Free plan.';
const $6663c77035b2c619$export$9a3aafa686359f8d = (contentId, isContentTypePublicLinkEligible, isUnpublishedDraft)=>{
    const shouldIncludePublicLink = (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? true : isContentTypePublicLinkEligible;
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($6663c77035b2c619$var$useShareAndRestrictButtonDataQuery, {
        variables: {
            contentId: contentId,
            isContentTypePublicLinkEligible: shouldIncludePublicLink
        },
        fetchPolicy: (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? 'cache-and-network' : 'network-only',
        errorPolicy: 'all'
    });
    const errors = [];
    if (error?.message.includes($6663c77035b2c619$var$EXPECTED_FREE_EDITION_PUBLIC_LINK_ERROR)) (0, $7Sm4c.markErrorAsHandled)(error);
    else if (error) errors.push(error);
    const hasRestrictions = Boolean(data?.singleContent?.hasRestrictions);
    const hasInheritedRestrictions = Boolean(data?.singleContent?.hasInheritedRestrictions);
    const hasViewRestrictions = Boolean(data?.singleContent?.hasViewRestrictions);
    const pageTitle = data?.singleContent?.title;
    const isPublicLinkOn = shouldIncludePublicLink ? data?.publicLinkPage?.pageStatus === 'ON' : false;
    const [icon, tooltipMessage] = $6663c77035b2c619$var$getIconAndTooltipFromData(isPublicLinkOn, hasInheritedRestrictions, hasViewRestrictions, Boolean(errors.length), isUnpublishedDraft, hasRestrictions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'shareAndRestrictButtonQuery',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    return {
        icon: icon,
        tooltipMessage: tooltipMessage,
        refetch: ()=>{
            refetch({
                contentId: contentId,
                isContentTypePublicLinkEligible: shouldIncludePublicLink
            });
        },
        // When navigating in SPA, the cache-and-network fetchPolicy will initially return the data
        // from the previous page if the current one has not been visited before. This check ensures
        // that we show the loading state when the data for this content is not actually available.
        isLoading: loading && !Boolean(data?.singleContent?.id === contentId),
        error: errors.length > 0 ? errors[0] : null,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isPublicLinkOn: isPublicLinkOn,
        pageTitle: pageTitle,
        isUnpublishedDraft: isUnpublishedDraft
    };
};



var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $0e2cc7602bd622b9$var$initialState = {
    hasClickedShareButton: false
};
const $0e2cc7602bd622b9$var$actions = {
    setHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: true
            });
        },
    resetHasClickedShareButton: ()=>({ setState: setState })=>{
            setState({
                hasClickedShareButton: false
            });
        }
};
const $0e2cc7602bd622b9$var$ShareAndRestrictButtonStore = (0, $1P1Tu.createStore)({
    initialState: $0e2cc7602bd622b9$var$initialState,
    actions: $0e2cc7602bd622b9$var$actions,
    name: 'ShareAndRestrictButtonStore'
});
const $0e2cc7602bd622b9$export$15991ed5dace2362 = (0, $9zUhf.createStateHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);
const $0e2cc7602bd622b9$export$6033af6626ad7b59 = (0, $9zUhf.createActionsHook)($0e2cc7602bd622b9$var$ShareAndRestrictButtonStore);









var $gqypm = parcelRequire("gqypm");

const $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
//THE GA Date of USD, any users onboarding on or after this date are considered new users
const $bcc2dd382176fa47$var$NEW_USER_FROM_DATE = new Date('2025-03-24');
const $bcc2dd382176fa47$export$750d18e9348a361a = ()=>{
    const $ = (0, $frIzR.c)(14);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const t0 = userId ?? "";
    let t1;
    if ($[0] !== cloudId || $[1] !== t0) {
        t1 = {
            cloudId: cloudId,
            userId: t0
        };
        $[0] = cloudId;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = !userId || !cloudId;
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)(t3);
    if (loading || error) {
        let t4;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                isNewUser: true
            };
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    let firstActiveDate;
    let t4;
    let t5;
    if ($[7] !== attributes) {
        const firstActiveValue = attributes?.find($bcc2dd382176fa47$var$_temp)?.value;
        firstActiveDate = new Date(firstActiveValue ?? "");
        t4 = isNaN;
        t5 = firstActiveDate.getTime();
        $[7] = attributes;
        $[8] = firstActiveDate;
        $[9] = t4;
        $[10] = t5;
    } else {
        firstActiveDate = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    const isValidDate = !t4(t5);
    if (!isValidDate) {
        let t6;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                isNewUser: true
            };
            $[11] = t6;
        } else t6 = $[11];
        return t6;
    }
    const t6 = Boolean(firstActiveDate >= $bcc2dd382176fa47$var$NEW_USER_FROM_DATE);
    let t7;
    if ($[12] !== t6) {
        t7 = {
            isNewUser: t6
        };
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
function $bcc2dd382176fa47$var$_temp(t0) {
    const { name: name } = t0;
    return name === $bcc2dd382176fa47$var$CONFLUENCE_FIRST_ACTIVE_TRAIT;
}



var $lT8a1 = parcelRequire("lT8a1");


var $grWYF = parcelRequire("grWYF");


var $dA1Sn = parcelRequire("dA1Sn");

// GALILEO-5536 START
// GALILEO-5536 END
const $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES = [
    'page',
    'whiteboard'
];
const $d1b365751f35aaca$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    shareButtonSpotlightHeading: {
        id: "share-and-restrict-dialog.spotlight.heading",
        defaultMessage: "Restrictions have moved"
    },
    shareButtonSpotlightText: {
        id: "share-and-restrict-dialog.spotlight.text",
        defaultMessage: "Now you can share and restrict access to your content in one place."
    },
    shareButtonSpotlightLearnMore: {
        id: "share-and-restrict-dialog.spotlight.learn-more",
        defaultMessage: "Learn more"
    },
    shareButtonSpotlightOk: {
        id: "share-and-restrict-dialog.spotlight.ok",
        defaultMessage: "OK"
    },
    shareButtonChangeBoardingFlagHeading: {
        id: "share-and-restrict-dialog.flag.heading",
        defaultMessage: "Your lock icon has moved"
    },
    shareButtonChangeBoardingFlagDescription: {
        id: "share-and-restrict-dialog.flag.message",
        defaultMessage: "The lock icon (where you manage access to your content) is now in the Share button."
    },
    shareButtonChangeBoardingFlagAction: {
        id: "share-and-restrict-dialog.flag.action",
        defaultMessage: "Show me"
    }
});
const $d1b365751f35aaca$var$useAccountIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('accountId');
const $d1b365751f35aaca$var$useUsernameQueryParam = (0, $dPJCf.createSingleQueryParamHook)('username');
const $d1b365751f35aaca$var$useGrantAccessQueryParam = (0, $dPJCf.createSingleQueryParamHook)('grantAccess');
const $d1b365751f35aaca$var$useAccessTypeQueryParam = (0, $dPJCf.createSingleQueryParamHook)('accessType');
const $d1b365751f35aaca$var$convertPageMode = (mode)=>mode === (0, $cD1qu.PageMode).LIVE ? (0, $cD1qu.PageMode).VIEW : mode;
const $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID = 'share-restrict-button-changeboarding-flag';
const $d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent = ({ contentId: contentId, shareeAction: shareeAction = 'view', allowRestrictions: allowRestrictions = true, contentType: contentType, contentSubType: contentSubType, isUnpublishedDraft: isUnpublishedDraft = false, flags: flags, isShareAndRestrictButtonDisabled: // Separate disabled states
isShareAndRestrictButtonDisabled = false, isCopyLinkButtonDisabled: isCopyLinkButtonDisabled = false, // CopyLinkButton props
...copyLinkButtonProps })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [controllerMounted, setControllerMounted] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    // Grant Access query params
    const accountId = $d1b365751f35aaca$var$useAccountIdQueryParam();
    const username = $d1b365751f35aaca$var$useUsernameQueryParam();
    const grantAccess = $d1b365751f35aaca$var$useGrantAccessQueryParam();
    const accessType = $d1b365751f35aaca$var$useAccessTypeQueryParam();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    // Hook to store share button click state
    const { setHasClickedShareButton: setHasClickedShareButton, resetHasClickedShareButton: resetHasClickedShareButton } = (0, $0e2cc7602bd622b9$export$6033af6626ad7b59)();
    // Create a ref for the share button
    const shareButtonRef = (0, $42omo.useRef)(null);
    const shouldShowGrantAccessDialog = grantAccess && accountId || username;
    const isContentTypePublicLinkEligible = $d1b365751f35aaca$var$PUBLIC_LINK_ENROLLED_CONTENT_TYPES.includes(contentType);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const { icon: // Used here for rendering the button
    icon, isLoading: isLoading, error: error, tooltipMessage: tooltipMessage, refetch: refetch, hasInheritedRestrictions: // Used here for analytics
    hasInheritedRestrictions, hasRestrictions: hasRestrictions, hasViewRestrictions: hasViewRestrictions, isPublicLinkOn: isPublicLinkOn, pageTitle: pageTitle } = (0, $6663c77035b2c619$export$9a3aafa686359f8d)(contentId, isContentTypePublicLinkEligible, isUnpublishedDraft);
    const { isNewUser: isNewUser } = (0, $bcc2dd382176fa47$export$750d18e9348a361a)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const dismissGrantAccessDialog = (0, $42omo.useCallback)(()=>{
        setQueryParams({
            grantAccess: undefined,
            accessType: undefined,
            accountId: undefined,
            username: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    const handleClick = (0, $42omo.useCallback)(()=>{
        if (renderServerPlaceholder) return;
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    actionSubject: 'button',
                    actionSubjectId: 'ShareAndRestrictButton',
                    action: 'clicked',
                    attributes: {
                        contentId: contentId,
                        contentSubType: contentSubType,
                        isLivePage: contentSubType === 'live',
                        isDraft: isUnpublishedDraft,
                        contentType: contentType,
                        edition: edition,
                        hasInheritedRestrictions: hasInheritedRestrictions,
                        hasRestrictions: hasRestrictions,
                        hasViewRestrictions: hasViewRestrictions,
                        isPublicLinkOn: isPublicLinkOn,
                        pageMode: shareeAction
                    }
                }
            }).fire();
            refetch();
            setControllerMounted(true);
            //mark has share button click to true
            setHasClickedShareButton();
            //start share and restrict dialog load experience
            experienceTracker.start({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
            });
        }
    }, [
        createAnalyticsEvent,
        contentId,
        contentSubType,
        contentType,
        edition,
        hasInheritedRestrictions,
        hasRestrictions,
        hasViewRestrictions,
        isUnpublishedDraft,
        isPublicLinkOn,
        refetch,
        shareeAction,
        experienceTracker,
        renderServerPlaceholder,
        setHasClickedShareButton
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedShareButton();
    }, [
        resetHasClickedShareButton
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'ShareAndRestrictButton',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    isDraft: isUnpublishedDraft,
                    pageMode: shareeAction
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentSubType,
        isUnpublishedDraft,
        shareeAction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && !error) experienceTracker.succeed({
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
        else if (!isLoading && error) experienceTracker.fail({
            error: error,
            name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
        });
    }, [
        error,
        isLoading,
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        if (edition !== (0, $d9tcB.ConfluenceEdition).FREE) (0, $6mKj3.manuallyLogExpExposure)('confluence_contextual_ask_to_edit');
    }, [
        edition
    ]);
    const { data: data, loading: loading, error: spotlightError } = (0, $ivb8S.useGetOnboardingState)((0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $42omo.useEffect)(()=>{
        if (data && !loading && !spotlightError && !error) {
            const spotlightSeen = data?.onboardingState?.find((prop)=>prop.key === (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN)?.value === 'true';
            // Live pages does not want users to see USD button change-boarding
            if (!(contentSubType == 'live' || isNewUser)) // If the spotlight hasn't been seen before
            {
                if (!spotlightSeen) {
                    const markSpotlightAsSeen = ()=>setOnboardingState({
                            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
                            value: 'true'
                        });
                    const onFlagDismissClick = ()=>{
                        markSpotlightAsSeen();
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag dismissed',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    const onFlagShowMeClick = ()=>{
                        setIsSpotlightActive(true);
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'spotlight shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                        flags.hideFlag($d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID);
                        markSpotlightAsSeen();
                    };
                    const showFlag = async ()=>{
                        await flags.showFlag({
                            id: $d1b365751f35aaca$var$CHANGEBOARDING_FLAG_ID,
                            type: 'custom',
                            title: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagHeading),
                            description: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagDescription),
                            actions: [
                                {
                                    content: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonChangeBoardingFlagAction),
                                    onClick: onFlagShowMeClick
                                }
                            ],
                            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
                                label: ""
                            }),
                            onClose: onFlagDismissClick,
                            close: 'auto'
                        });
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                                actionSubject: 'ShareAndRestrictButton',
                                action: 'flag shown',
                                attributes: {
                                    contentId: contentId,
                                    contentSubType: contentSubType,
                                    isLivePage: false,
                                    contentType: contentType,
                                    edition: edition,
                                    hasInheritedRestrictions: hasInheritedRestrictions,
                                    hasRestrictions: hasRestrictions,
                                    hasViewRestrictions: hasViewRestrictions,
                                    isPublicLinkOn: isPublicLinkOn,
                                    pageMode: shareeAction
                                }
                            }
                        }).fire();
                    };
                    showFlag();
                }
            }
        } else if (spotlightError && !loading) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'ShareAndRestrictButton',
                action: 'spotlight failed',
                attributes: {
                    contentId: contentId,
                    contentSubType: contentSubType,
                    isLivePage: contentSubType === 'live',
                    contentType: contentType,
                    edition: edition,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    hasRestrictions: hasRestrictions,
                    hasViewRestrictions: hasViewRestrictions,
                    isPublicLinkOn: isPublicLinkOn,
                    pageMode: shareeAction
                }
            }
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        loading,
        spotlightError,
        error
    ]);
    const endSpotlight = ()=>{
        // Change spotlight state to only show once
        setOnboardingState({
            key: (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).DIALOG_SPOTLIGHT_SEEN,
            value: 'true'
        });
        setIsSpotlightActive(false);
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const learnMoreClicked = ()=>{
        endSpotlight();
        window.open((0, $4adOe.SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION), '_blank', 'noreferrer');
    };
    const renderControlledShareButton = ()=>{
        const indicatorRightOffset = icon === 'public' ? 54 : 55;
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d35qt.NewAccessRequestIndicator), {
            top: 4,
            right: indicatorRightOffset,
            source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Qy97i.ControlledShareButton), {
            tooltipMessage: tooltipMessage,
            icon: icon,
            onClick: handleClick,
            isDisabled: isShareAndRestrictButtonDisabled || isNetworkDisabled,
            focusRef: shareButtonRef
        }));
        // GALILEO-5536 START
        if ((0, $9wGTI.fg)('twcg-392_export_jira_context_to_page_killswitch')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6fwOO.ExperimentExportJiraContextToPageNudgeSpotlightStepWrapper), {
            stepIndex: 1
        }, button);
        // GALILEO-5536 END
        return button;
    };
    const renderGrantAccessFlagAndUsdButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }), renderControlledShareButton());
    const renderGrantAccessDialogAndUsdButton = ()=>shouldShowGrantAccessDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u6LZ.GrantAccessDialogLoader), {
            accessType: accessType === 'edit' ? 'edit' : 'view',
            accountId: accountId || username || '',
            buttonPlaceholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null),
            contentId: contentId,
            isOpen: !renderServerPlaceholder,
            onActionClick: dismissGrantAccessDialog,
            shouldSSRGrantAccessRestrictions: (0, $9wGTI.fg)('confluence_frontend_usd_ssr')
        }, renderControlledShareButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderControlledShareButton());
    const pageMode = $d1b365751f35aaca$var$convertPageMode((0, $aSsfA.useGetPageMode)());
    const spaceKey = (0, $cLo2u.useSpaceKey)() ?? '';
    const { shouldShowGrantAccess: shouldShowGrantAccess, clearGrantAccessQueryParams: clearGrantAccessQueryParams } = (0, $913c9f7b92c5afc8$export$2914b3c0c287db)();
    const [initialDialog, setInitialDialog] = (0, $42omo.useState)(shouldShowGrantAccess && edition !== 'FREE' && (0, $9wGTI.fg)('confluence_frontend_stateful_access_requests') ? 'accessRequests' : undefined);
    (0, $42omo.useLayoutEffect)(()=>{
        if (initialDialog) setControllerMounted(true);
    }, [
        initialDialog
    ]);
    const openAccessRequestsDialog = (0, $42omo.useCallback)(()=>{
        setInitialDialog('accessRequests');
    }, []);
    const clearInitialDialog = (0, $42omo.useCallback)(()=>{
        setInitialDialog(undefined);
        clearGrantAccessQueryParams();
    }, [
        clearGrantAccessQueryParams
    ]);
    const renderGrantAccessFlagOrDialog = ()=>(0, $9wGTI.fg)('confluence_frontend_grant_access_flag') ? renderGrantAccessFlagAndUsdButton() : renderGrantAccessDialogAndUsdButton();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "share-button",
        enabled: (0, $6mKj3.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "share-restrict-and-copy-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "share-button-spotlight-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "shareAndRestrictButton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6DT7W.RequestAccessPopupComponent), {
        contentId: contentId
    }), (0, $9wGTI.fg)('confluence_frontend_stateful_access_requests') ? renderControlledShareButton() : renderGrantAccessFlagOrDialog()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        actions: [
            {
                onClick: endSpotlight,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightOk)
            },
            {
                onClick: learnMoreClicked,
                text: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightLearnMore)
            }
        ],
        heading: formatMessage($d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightHeading),
        target: "shareAndRestrictButton",
        key: "shareAndRestrict-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)",
        dialogPlacement: "bottom right",
        dialogWidth: 275
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        values: {
            bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
        },
        ...$d1b365751f35aaca$export$a7357cdd1f0b0168.shareButtonSpotlightText
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $grWYF.OnboardingPagePermissionsSpotlightLoader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.SHARE_PAGE_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_SHARE_PAGE_SHORTCUT),
        listener: handleClick
    })), !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        key: contentId,
        customData: {
            shareButtonType: 'ShareAndRestrictButton'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        isDisabled: isCopyLinkButtonDisabled,
        ...copyLinkButtonProps
    }))), controllerMounted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4adOe.Controller), {
        contentId: contentId,
        contentType: contentType,
        contentSubType: contentSubType,
        allowRestrictions: allowRestrictions,
        pageTitle: pageTitle,
        pageMode: shareeAction,
        refetchButtonData: refetch,
        onClose: ()=>{
            setControllerMounted(false);
        },
        isUnpublishedDraft: isUnpublishedDraft,
        focusRef: shareButtonRef,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        isSuperAdmin: isSuperAdmin,
        initialDialog: initialDialog,
        onInitialDialogOpen: clearInitialDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7b8f942bb046fc6$export$6ad2e2265e081d0a), {
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        onReviewRequestsClick: openAccessRequestsDialog
    }));
};
const $d1b365751f35aaca$export$d9b7b2c2d990f8ed = (0, $7aRa9.withFlags)($d1b365751f35aaca$var$ShareRestrictAndCopyCoordinatorComponent);
module.exports["i18n"] = $d1b365751f35aaca$export$a7357cdd1f0b0168;
module.exports["ShareRestrictAndCopyCoordinator"] = $d1b365751f35aaca$export$d9b7b2c2d990f8ed;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("7aRa9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $42omo.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("fUQ5E"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("fUQ5E", function(module, exports) {

let $b9647dfa6f93a212$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b9647dfa6f93a212$var$load("6wr18"),
    $b9647dfa6f93a212$var$load("8Tr2S"),
    $b9647dfa6f93a212$var$load("h4Nf7"),
    $b9647dfa6f93a212$var$load("ffEVr"),
    $b9647dfa6f93a212$var$load("76iIp"),
    $b9647dfa6f93a212$var$load("az9CK"),
    $b9647dfa6f93a212$var$load("iqKwT"),
    $b9647dfa6f93a212$var$load("lk4cE")
]).then(()=>parcelRequire('1hgMC'));

});

parcelRegister("b8XTE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $3kTfj = parcelRequire("3kTfj");


var $1NBp8 = parcelRequire("1NBp8");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");

const $eb0c119b7155e6d7$var$noop = ()=>{};
const $eb0c119b7155e6d7$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $42omo.memo)(({ customData: customData = {}, metric: metric, onComplete: onComplete = $eb0c119b7155e6d7$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete })=>{
    // Use refs to avoid firing handlePageSegmentLoadMetricStop more than once despite changes to stopTime or customData
    const stopTimeRef = (0, $42omo.useRef)(stopTime);
    const customDataRef = (0, $42omo.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $42omo.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handlePageSegmentLoadMetricStop = (0, $42omo.useCallback)(()=>{
        if (metric) {
            onComplete();
            let finalCustomData;
            if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
            else finalCustomData = customDataRef.current;
            const { route: route } = metric.getData();
            const shouldAddViewTransitionSource = route === (0, $1NBp8.VIEW_PAGE).name || route === (0, $1NBp8.VIEW_BLOG).name;
            if (shouldAddViewTransitionSource) finalCustomData.viewTransitionSource = (0, $lXYVJ.getViewTransitionSource)();
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${metric.key}`);
            metric.stop({
                customData: {
                    ...finalCustomData,
                    previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
                    previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                stopTime: stopTimeRef.current
            });
        }
    }, [
        metric,
        onComplete
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageSegmentLoadMetricStop, timing);
    return null;
}, /**
	 * Use lodash isEqual as comparator to avoid unnecessary re-renders
	 * i.e. when an object is defined directly within customData prop
	 * `<PageLoadSegmentEnd ... customData={{ data: 'example' }} />`
	 * (Export only for testing)
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));
const $eb0c119b7155e6d7$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($eb0c119b7155e6d7$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $eb0c119b7155e6d7$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["RECENT_DROPDOWN_ITEM_CLICK"] = $f3fed16e32582dfc$export$e20b00d7fdb37fd5;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $diswb = parcelRequire("diswb");


var $6jrkJ = parcelRequire("6jrkJ");


var $kOBmw = parcelRequire("kOBmw");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $diswb.useQuery)((0, $kOBmw.IsSuperAdmin), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("kOBmw", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1f121c69ed56862b$export$b43e9b817e671e28 = (0, $eSUdr.default)`query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id confluence{roles{isSuperAdmin}}}}`;
module.exports["IsSuperAdmin"] = $1f121c69ed56862b$export$b43e9b817e671e28;

});

parcelRegister("6fwOO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/jsx-boolean-value */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");


var $gj7hi = parcelRequire("gj7hi");


var $5Mmzd = parcelRequire("5Mmzd");


var $8lKIo = parcelRequire("8lKIo");


var $6yyWj = parcelRequire("6yyWj");


var $inPa6 = parcelRequire("inPa6");


var $daw2l = parcelRequire("daw2l");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");

const $12b6fa95758c8d8a$var$SpotlightTourContext = /*#__PURE__*/ (0, $42omo.createContext)({
    currentStep: null,
    isEnrolled: false
}); // Move cssMap to top-level scope
const $12b6fa95758c8d8a$var$SpotlightBodyStyles = {
    root: "_195gmgjw"
};
const $12b6fa95758c8d8a$var$imageStyles = null; // Generic step content component
const $12b6fa95758c8d8a$var$SpotlightStep = ({ currentStep: currentStep, totalSteps: totalSteps, headlineMessage: headlineMessage, bodyMessage: bodyMessage, image: image, paddingInline: paddingInline = 'space.200', showBackButton: showBackButton = false, primaryActionLabel: primaryActionLabel, onBack: onBack, footerOrder: footerOrder = 'count-first' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage(headlineMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $12b6fa95758c8d8a$var$SpotlightBodyStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: paddingInline,
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(bodyMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1wug"
        ])
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, footerOrder === 'actions-first' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))))));
};
const $12b6fa95758c8d8a$export$8343e683bc14cced = ({ children: children, shouldShowTour: shouldShowTour, isEnrolled: isEnrolled = false, onTourComplete: onTourComplete, onTourDismiss: onTourDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentStep, setCurrentStep] = (0, $42omo.useState)(shouldShowTour && isEnrolled ? 0 : null);
    const totalSteps = 2; // Step 1 (page title) and Step 2 (share button)
    (0, $42omo.useEffect)(()=>{
        if (shouldShowTour && isEnrolled) // Wait for one frame to ensure layout has settled and targets are in DOM
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                setCurrentStep(0);
            });
        });
        else setCurrentStep(null);
    }, [
        shouldShowTour,
        isEnrolled
    ]);
    const next = ()=>{
        setCurrentStep((prev)=>{
            if (prev === null) return 0; // Track next action with current step before moving forward
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'next',
                step: prev
            });
            const nextStep = prev + 1;
            if (nextStep >= totalSteps) {
                endTour(true);
                return null;
            }
            return nextStep;
        });
    };
    const back = ()=>{
        setCurrentStep((prev)=>prev === null ? 0 : Math.max(prev - 1, 0));
    };
    const endTour = (isComplete)=>{
        const stepToTrack = currentStep;
        setCurrentStep(null); // Track dismissal or completion
        if (isComplete) {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'completed',
                step: stepToTrack
            });
            if (onTourComplete) onTourComplete();
        } else {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'dismissed',
                step: stepToTrack
            });
            if (onTourDismiss) onTourDismiss();
        }
    };
    const done = ()=>endTour(true);
    const dismiss = ()=>endTour(false); // Handle errors and send operational event
    const handleError = (0, $42omo.useCallback)((error, errorInfo)=>{
        (0, $daw2l.trackErrorEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            error: error,
            errorInfo: errorInfo,
            componentName: 'export-jira-context-nudge-spotlight-tour'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
        renderOnError: ()=>children,
        onError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightTourContext.Provider, {
        value: (0, $42omo.useMemo)(()=>({
                currentStep: currentStep,
                isEnrolled: isEnrolled
            }), [
            currentStep,
            isEnrolled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children, currentStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "left-end",
        dismiss: dismiss,
        done: next
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepOneHeadline,
        bodyMessage: (0, $6yyWj.messages).stepOneBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5Mmzd))),
        showBackButton: false,
        primaryActionLabel: (0, $6yyWj.messages).next,
        onBack: undefined,
        footerOrder: "count-first"
    })), currentStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "bottom-start",
        dismiss: dismiss,
        done: done
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepTwoHeadline,
        bodyMessage: (0, $6yyWj.messages).stepTwoBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8lKIo))),
        showBackButton: true,
        primaryActionLabel: (0, $6yyWj.messages).done,
        onBack: back,
        footerOrder: "count-first"
    })))));
};
const $12b6fa95758c8d8a$export$1c3dc5815d8870ee = ({ children: children, stepIndex: stepIndex })=>{
    const { currentStep: currentStep, isEnrolled: isEnrolled } = (0, $42omo.useContext)($12b6fa95758c8d8a$var$SpotlightTourContext); // Only render as PopoverTarget when this step is active and user is enrolled
    // PopoverProvider can only handle one PopoverTarget at a time
    const shouldRenderTarget = currentStep === stepIndex && isEnrolled;
    if (shouldRenderTarget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
     // Otherwise just render children normally
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightTour"] = $12b6fa95758c8d8a$export$8343e683bc14cced;
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightStepWrapper"] = $12b6fa95758c8d8a$export$1c3dc5815d8870ee;

});

parcelRegister("k7Tf7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $2MPqq = parcelRequire("2MPqq");

const $94cea1b432ccea5e$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2MPqq.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
            children: children
        })
    });
};
module.exports["PopoverProvider"] = $94cea1b432ccea5e$export$bf694c7c431c162a;

});

parcelRegister("a90ar", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs0ez = parcelRequire("cs0ez");

const $fcb2cc293f5cb422$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
module.exports["PopoverTarget"] = $fcb2cc293f5cb422$export$5ad0c0856b469f13;

});

parcelRegister("3chlW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $497b092596857daa$var$styles = {
    root: "_1bsb1osq"
};
const $497b092596857daa$export$205c28213090dc52 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $497b092596857daa$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});
module.exports["SpotlightActions"] = $497b092596857daa$export$205c28213090dc52;

});

parcelRegister("f1UQW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $8f17e6224eab722b$var$styles = {
    root: "_18zrpxbi _syaz15cr _1q51u2gc"
};
const $8f17e6224eab722b$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $8f17e6224eab722b$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightBody"] = $8f17e6224eab722b$export$4ae665cf62a00c3f;

});

parcelRegister("71521", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $2MPqq = parcelRequire("2MPqq");


var $jEGan = parcelRequire("jEGan");

const $632f68eebac3d948$var$styles = {
    root: "_kqswh2mm",
    card: "_2rko1mok _zulpu2gc _kqswstnw _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax"
};
const $632f68eebac3d948$var$placementStyles = {
    'top-start': "_u7co12x7 _rjxpc7mi",
    'top-center': "_u7co12x7 _1e021qz4",
    'top-end': "_u7co12x7 _1e02c7mi",
    'right-start': "_1e0212x7 _u7comgjw",
    'right-end': "_1e0212x7 _152tmgjw",
    'bottom-start': "_152t12x7 _rjxpc7mi",
    'bottom-center': "_152t12x7 _1e021qz4",
    'bottom-end': "_152t12x7 _1e02c7mi",
    'left-start': "_rjxp12x7 _u7comgjw",
    'left-end': "_rjxp12x7 _152tmgjw"
};
const $632f68eebac3d948$export$14710e13fc01d383 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const cardRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $632f68eebac3d948$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jEGan.Caret), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $1Whri.cx)($632f68eebac3d948$var$styles.card, $632f68eebac3d948$var$placementStyles[card.placement]),
                children: children
            })
        ]
    });
});
module.exports["SpotlightCard"] = $632f68eebac3d948$export$14710e13fc01d383;

});

parcelRegister("jEGan", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2MPqq = parcelRequire("2MPqq");

const $8ca37cde5226694e$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswh2mm _1bsbo7ao _1pby1fw0",
    'top-start': "_t9ec71a3",
    'top-center': "_t9ec71a3",
    'top-end': "_t9ec71a3",
    'bottom-start': "_t9ec1hke",
    'bottom-center': "_t9ec1hke",
    'bottom-end': "_t9ec1hke",
    'right-start': "_t9ecjyd4",
    'right-end': "_t9ecjyd4",
    'left-start': "_t9ecebzf",
    'left-end': "_t9ecebzf"
};
const $8ca37cde5226694e$export$88fca06e22f21720 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gMc0m.default)([
            $8ca37cde5226694e$var$styles.root,
            $8ca37cde5226694e$var$styles[card.placement]
        ])
    });
});
module.exports["Caret"] = $8ca37cde5226694e$export$88fca06e22f21720;

});

parcelRegister("aVS0S", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b2d7675e2e3d4813$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21sbv"
};
const $b2d7675e2e3d4813$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gMc0m.default)([
            $b2d7675e2e3d4813$var$styles.root
        ]),
        children: children
    });
});
module.exports["SpotlightControls"] = $b2d7675e2e3d4813$export$67fb68d4ebe55a86;

});

parcelRegister("2owmo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $2MPqq = parcelRequire("2MPqq");

const $e90e33f81b492555$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27",
    rootT26Shape: "_2rko1qi0"
};
const $e90e33f81b492555$export$4eef19754b0d485e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $1Whri.cx)($e90e33f81b492555$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $e90e33f81b492555$var$styles.rootT26Shape),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "Close"
        })
    });
});
module.exports["SpotlightDismissControl"] = $e90e33f81b492555$export$4eef19754b0d485e;

});

parcelRegister("eopLP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $c18394162d9dc107$var$styles = {
    root: "_bozgpxbi _y4tiutpp _1bsb1osq"
};
const $c18394162d9dc107$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $c18394162d9dc107$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});
module.exports["SpotlightFooter"] = $c18394162d9dc107$export$f76dbc85ba76ccc2;

});

parcelRegister("aZQ5F", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $ad24be9a70db7ad2$var$styles = {
    root: "_bozgpxbi _y4tiutpp"
};
const $ad24be9a70db7ad2$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $ad24be9a70db7ad2$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});
module.exports["SpotlightHeader"] = $ad24be9a70db7ad2$export$d646029b3ba8ab76;

});

parcelRegister("bUJpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $2MPqq = parcelRequire("2MPqq");

const $7a1f3efc02714981$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});
module.exports["SpotlightHeadline"] = $7a1f3efc02714981$export$b57275b1b6b9863b;

});

parcelRegister("fNcP1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $456a9b1f10f70d47$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d8yml _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $456a9b1f10f70d47$export$eea27caf91a85655 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $456a9b1f10f70d47$var$styles.root,
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightPrimaryAction"] = $456a9b1f10f70d47$export$eea27caf91a85655;

});

parcelRegister("19Jj3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $b6d455d4ca0de162$var$styles = {
    root: "_2rko12b0 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $b6d455d4ca0de162$export$869dfff69399fe87 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $b6d455d4ca0de162$var$styles.root,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightSecondaryAction"] = $b6d455d4ca0de162$export$869dfff69399fe87;

});

parcelRegister("aG6kF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $2d58ceeae1d26536$var$styles = {
    root: "_1ul91ris"
};
const $2d58ceeae1d26536$export$f4d9def8bfebca = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $2d58ceeae1d26536$var$styles.root,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: "steps"
                })
            ]
        })
    });
});
module.exports["SpotlightStepCount"] = $2d58ceeae1d26536$export$f4d9def8bfebca;

});

parcelRegister("5Mmzd", function(module, exports) {
module.exports = new URL("step-one.dcc386c3.svg", import.meta.url).toString();

});

parcelRegister("8lKIo", function(module, exports) {
module.exports = new URL("step-two.cd055733.svg", import.meta.url).toString();

});

parcelRegister("6yyWj", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $96b51e9a0b93ad79$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // Step 1 messages
    stepOneHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.headline",
        defaultMessage: "Your plans start here"
    },
    stepOneBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.body",
        defaultMessage: "We've embedded your Jira timeline into this doc so you can work while staying in sync across platforms."
    },
    // Step 2 messages
    stepTwoHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.headline",
        defaultMessage: "Share to keep everyone in sync"
    },
    stepTwoBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.body",
        defaultMessage: "Share this page with your team so everyone can see the latest updates in real time."
    },
    // Step 3 messages
    stepThreeHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.headline",
        defaultMessage: "Keep building this doc"
    },
    stepThreeBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.body",
        defaultMessage: "Type / to insert elements like headers, tables, columns and more."
    },
    // Common action buttons
    next: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.dismiss",
        defaultMessage: "Dismiss"
    },
    stepCount: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-count",
        defaultMessage: "{current} of {total}"
    }
});
module.exports["messages"] = $96b51e9a0b93ad79$export$defe85febe8b728c;

});

parcelRegister("daw2l", function(module, exports) {
const $904f0f764f52098e$export$648b2bd0c915d9fe = ({ createAnalyticsEvent: createAnalyticsEvent, action: action, step: step })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: 'confluence',
            actionSubject: 'spotlight',
            action: 'actioned',
            attributes: {
                action: action,
                step: step !== null ? step : undefined
            }
        }
    }).fire();
};
const $904f0f764f52098e$export$d4b1091dbd9649e3 = ({ createAnalyticsEvent: createAnalyticsEvent, error: error, errorInfo: errorInfo, componentName: componentName })=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'reported',
            actionSubject: `${componentName}-error`,
            source: 'confluence',
            attributes: {
                name: error.name,
                msg: error.message,
                stack: error.stack,
                componentStack: errorInfo.componentStack
            }
        }
    }).fire();
};
module.exports["trackSpotlightEvent"] = $904f0f764f52098e$export$648b2bd0c915d9fe;
module.exports["trackErrorEvent"] = $904f0f764f52098e$export$d4b1091dbd9649e3;

});

parcelRegister("i9VoI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $42omo.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $kyKWe = parcelRequire("kyKWe");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $gKr8t = parcelRequire("gKr8t");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $42omo.useState)(null);
    const [contentId, setContentId] = (0, $42omo.useState)(null);
    const [contentType, setContentType] = (0, $42omo.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $42omo.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $42omo.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = subscribers[delta].filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $42omo.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            if (subscribers.hasOwnProperty(delta)) (subscribers?.[delta]).forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { error: error } = (0, $diswb.useSubscription)((0, $eSUdr.default)`subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type id accountId __typename _deltas contentStateUpdated{key value version __typename}emojiTitleUpdated{key value version __typename}coverPictureUpdated{key value version __typename}pageTitlePropertyUpdated{key value version __typename}coverPictureDeleted{key __typename}emojiTitleDeleted{key __typename}contentStateDeleted{key __typename}coverPictureWidthUpdated{coverPictureWidth __typename}pageBlogified{spaceKey spaceName blogTitle converterDisplayName __typename}embedUpdated{product isBlankStateUpdate __typename}pageMigrated{fabricEligibility __typename}contentRestrictionUpdated{contentId __typename}pageMoved{oldSpaceKey newSpaceKey oldParentId oldPosition newSpaceAlias oldSpaceAlias __typename}pageUpdated{__typename trigger confVersion}contentUpdatedWithTemplate{spaceKey subtype __typename}inlineCommentCreated{commentId inlineCommentType adfBodyContent __typename markerRef}rendererInlineCommentCreated{__typename commentId adfBodyContent inlineCommentType markerRef publishVersionNumber step{from to pos mark{attrs{annotationType __typename}__typename}__typename}}editorInlineCommentCreated{adfBodyContent commentId inlineCommentType markerRef __typename}inlineCommentUpdated{commentId markerRef __typename}inlineCommentDeleted{commentId inlineCommentType markerRef __typename}inlineCommentResolved{commentId inlineResolveProperties{isDangling resolved resolvedByDangling resolvedFriendlyDate resolvedTime resolvedUser __typename}inlineText markerRef replies __typename}inlineCommentUnresolved{commentId markerRef __typename}inlineCommentReattached{commentId __typename markerRef publishVersionNumber step{from mark{attrs{__typename annotationType}__typename}__typename}}commentCreated{__typename adfBodyContent commentId pageCommentType}commentUpdated{__typename commentId}commentDeleted{__typename commentId}commentResolved{__typename adfBodyContent commentId pageCommentType replies}commentReopened{__typename commentId}schedulePublished{publishTime eventType confVersion __typename}contentAccessRequested{contentId __typename}contentAccessDecisionMade{contentId decision __typename}}}`, {
        variables: {
            id: id,
            __extensions: extensions
        },
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(subscriptionData?.data?.confluence_onContentModified ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = error?.errors?.[0]?.extensions?.statusCode;
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $42omo.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("3vc4U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$OLD_REPLAY_WINDOW_HOURS = 24;
const $e5d99b79ae0d2558$var$NEW_REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $42omo.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $42omo.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $42omo.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $42omo.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $42omo.useMemo)(()=>{
        const replayWindowHours = (0, $9wGTI.fg)('confluence_frontend_comments_extend_replay_window') ? $e5d99b79ae0d2558$var$NEW_REPLAY_WINDOW_HOURS : $e5d99b79ae0d2558$var$OLD_REPLAY_WINDOW_HOURS;
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - replayWindowHours * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("gw4Bt", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<75f3aefb9253410ca405956fa01a2346>>
 * @relayHash 43e22200d20c9054da6f6b002b467f53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "43e22200d20c9054da6f6b002b467f53",
            "id": "3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "3f2ed67e9608ba74e2a432234c7f66f7";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("grWYF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $2Fndw = parcelRequire("2Fndw");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $4adOe = parcelRequire("4adOe");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $frIzR.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $frIzR.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const hasRun = (0, $42omo.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $42omo.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("dA1Sn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $42omo.useState)(isNoSSR || !fullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $42omo.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { style: style, name: name, children: children, enabled: t1 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t2;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[0] = t2;
            } else t2 = $[0];
            let t3;
            if ($[1] !== children || $[2] !== name) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    style: t2
                }, children);
                $[1] = children;
                $[2] = name;
                $[3] = t3;
            } else t3 = $[3];
            return t3;
        }
        const innerHTML = fullCycleOutput;
        let t2;
        if ($[4] !== innerHTML) {
            t2 = {
                __html: innerHTML
            };
            $[4] = innerHTML;
            $[5] = t2;
        } else t2 = $[5];
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== name || $[8] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                dangerouslySetInnerHTML: t2,
                style: t3
            });
            $[7] = name;
            $[8] = t2;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t2;
    if ($[14] !== innerHTML_0) {
        t2 = {
            __html: innerHTML_0
        };
        $[14] = innerHTML_0;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== name || $[17] !== style || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t2
        });
        $[16] = name;
        $[17] = style;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { name: name, style: style, children: children, enabled: t1 } = t0;
    const enabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== style) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = style;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;
module.exports["default"] = $830764d8fffe9f5a$export$2e2bcd8739ae039;

});

parcelRegister("fEmGS", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    return $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data, variables: variables } = params;
    if (!data) return;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, root, queryFields, data, variables || {});
    });
}
function $f0827a369f0dafa9$var$writeQueryFields(storeProxy, record, fields, data, variables) {
    if (!record || !data) return;
    for (const field of fields){
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const fieldData = data[linkedField.name];
            if (fieldData !== undefined) {
                if (Array.isArray(fieldData)) {
                    const linkedRecords = fieldData.map((item)=>{
                        if (item && typeof item === 'object') {
                            const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                            const existingRecord = record.getLinkedRecord(fieldKey);
                            if (existingRecord && linkedField.selections) {
                                $f0827a369f0dafa9$var$writeQueryFields(storeProxy, existingRecord, linkedField.selections, item, variables);
                                return existingRecord;
                            }
                        }
                        return null;
                    }).filter((rec)=>rec !== null);
                    if (linkedRecords.length > 0) {
                        const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                        record.setLinkedRecords(linkedRecords, fieldKey);
                    }
                } else if (fieldData && typeof fieldData === 'object') {
                    const fieldKey = $f0827a369f0dafa9$var$getFieldKey(linkedField, variables);
                    const linkedRecord = record.getLinkedRecord(fieldKey);
                    // If no linked record exists but we have data with an ID, we can try to get the existing record,
                    // or create a new record based on __typename. However, this shouldn't be a common use-case across the codebase,
                    // so we'll skip these code paths for now
                    if (linkedRecord && linkedField.selections) $f0827a369f0dafa9$var$writeQueryFields(storeProxy, linkedRecord, linkedField.selections, fieldData, variables);
                }
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            if (data[scalarField.name] !== undefined) record.setValue(data[scalarField.name], scalarField.name);
        }
    }
}
function $f0827a369f0dafa9$var$getFieldKey(field, variables) {
    if (!field.args || field.args.length === 0) return field.name;
    // Compute storage key for fields with arguments
    const args = field.args.map((arg)=>{
        let value;
        if (arg.kind === 'Literal') value = JSON.stringify(arg.value);
        else if (arg.kind === 'Variable') value = JSON.stringify(variables[arg.variableName]);
        else // Fallback for other argument types
        value = JSON.stringify(arg.value);
        return `${arg.name}:${value}`;
    }).join(',');
    return `${field.name}(${args})`;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("l1uFv", function(module, exports) {

var $86okN = parcelRequire("86okN");

function $65c7b8940c778902$export$627cb922211284f(params) {
    return $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("e3X7L", function(module, exports) {
/**
 * @generated SignedSource<<018f680a41f998d85b2f3329e18a2d4f>>
 * @relayHash 6ea58338105a015fd443972b8fa8bd85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64
const $05607cbb6652fe1b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GrantAccessDialogLoaderQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6ea58338105a015fd443972b8fa8bd85",
            "id": "c621ba09ccc6f35017033687da8b71cefb7d4fe258097148bd0d767f32870c64",
            "metadata": {},
            "name": "GrantAccessDialogLoaderQuery",
            "operationKind": "query",
            "text": "query GrantAccessDialogLoaderQuery($contentId:ID!,$accountId:ID!){singleContent(id:$contentId){id,title},user:confluence_atlassianUser(id:$accountId){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$05607cbb6652fe1b$var$node.hash = "65e9fca072feda54403e4da52299bc66";
var $05607cbb6652fe1b$export$2e2bcd8739ae039 = $05607cbb6652fe1b$var$node;
module.exports["default"] = $05607cbb6652fe1b$export$2e2bcd8739ae039;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});


//# sourceMappingURL=ShareRestrictAndCopyCoordinator.acd9a1f8.js.map
